// Image path configuration
// This config constructs the full URL for profile and banner images using the filename returned by the API

const IMAGE_BASE_URL = "https://backendapi.edjamon.com/uploads";

/**
 * Construct full image URL from filename
 * @param {string} filename - The image filename returned by the API
 * @returns {string|null} - The full image URL or null if filename is not provided
 */
export const getImageUrl = (filename) => {
  if (!filename) return null;
  return `${IMAGE_BASE_URL}/${filename}`;
};

export default {
  IMAGE_BASE_URL,
  getImageUrl,
};
